import { all, call } from "redux-saga/effects";

import watchWheelSaga from "./wheel";

export function* wheelSaga() {
	yield all([
		call(watchWheelSaga),
	]);
}
